import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import LandingPage from "./pages/LandingPage";
import SchedulingPage from "./pages/SchedulingPage";
import CommandCenter from "./nexsys/CommandCenter";
import KioskMode from "./nexsys/KioskMode";
import { NexsysGate } from "./nexsys/gate";
import AdminPanel from "./nexsys/AdminPanel";
import RecoverPage from "./RecoverPage";
import { ChattyProvider } from "./chatty/ChattyContext";
import Chatty from "./chatty/Chatty";

function NexsysRoute() {
  const isKiosk = new URLSearchParams(window.location.search).get("kiosk") === "1";
  if (isKiosk) return <KioskMode />;
  return <NexsysGate><CommandCenter /></NexsysGate>;
}

function App() {
  const isKiosk = new URLSearchParams(window.location.search).get("kiosk") === "1";
  return (
    <BrowserRouter>
      <ChattyProvider>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/scheduling" element={<SchedulingPage />} />
          <Route path="/nexsys" element={<NexsysRoute />} />
          <Route path="/admin" element={<NexsysGate><AdminPanel /></NexsysGate>} />
          <Route path="/recover" element={<RecoverPage />} />
        </Routes>
        {!isKiosk && <Chatty />}
      </ChattyProvider>
    </BrowserRouter>
  );
}

export default App;
